// extracted by mini-css-extract-plugin
module.exports = {"main":"Quotes_main__1n7Z6"};